import { Card, Dialog, DialogActions, DialogTitle, Stack } from '@mui/material';
import { WrappedPatient } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Patient';
import { i18nFunction } from 'src/careflow/ph-core/internationalization/hook/useLocales';
import SearchMember, { SearchMemberProps } from './SearchMember';
import CancelButton from 'src/careflow/common/CancelButton';

const GenericSearchMemberModal = ({
  patient,
  isSearchMemberOpen,
  handleSave,
  title,
  resource,
  filter,
  i18n,
  handleClose,
}: {
  patient?: WrappedPatient | null;
  isSearchMemberOpen: boolean;
  handleSave: any;
  title: string;
  resource: SearchMemberProps['externalResourceType'];
  filter?: { relationship: string };
  i18n: i18nFunction;
  handleClose: VoidFunction;
}) => (
  <Dialog open={isSearchMemberOpen} fullWidth={true} maxWidth="md">
    <DialogTitle>{title}</DialogTitle>
    <Card sx={{ m: 2 }}>
      <Stack sx={{ m: 2 }}>
        <SearchMember
          patient={patient as WrappedPatient}
          onSelectResource={(resource) => handleSave(resource)}
          onClear={() => handleClose()}
          externalResourceType={resource}
          filterRelatedPerson={filter}
        />
      </Stack>
      <DialogActions>
        <CancelButton onClick={handleClose}>{i18n('cancel')}</CancelButton>
      </DialogActions>
    </Card>
  </Dialog>
);

export default GenericSearchMemberModal;
